<template>
  <header class="site-header">
    <nav class="navbar">
      <div class="logo">
        <a class="logo-link" href="/">
          <img src="../../assets/cdnbye.png" />
        </a>
      </div>
      <div class="banner">
        <h5>To get started, click “Simulate Peer” twice. Two new tabs open, simulating other viewers watching the same content.</h5>
      </div>
      <div class="git">
        <a href="https://github.com/cdnbye/hlsjs-p2p-engine" target="_blank">
        <i class="fa fa-github fa-2x"></i>
        </a>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style>
  .site-header {
    width: 100% !important;
    box-sizing: border-box;
    box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.1), 0 1px rgba(0,0,0,0.1);
    background: #fafafa;
    background-color: #00BCD4;
  }
  .navbar {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .logo {
    float: left;
  }
  .logo-link {
    display: inline-block;
    padding-top: 0.3125rem;
    padding-bottom: 0.3125rem;
    margin-right: 1rem;
    font-size: 1.25rem;
    line-height: inherit;
    white-space: nowrap;
  }
  .logo-link img {
    width: 100px;
    height: auto;
  }
  .git {
    float: right;
  }
  .git a {
    font-size: 1.125rem;
  }
  .banner {
    color: #fff;
    font-size: 1.4rem;
    font-family: Comic Sans MS;
  }
</style>
